import styled, { css } from 'styled-components'

import { textOverflowStyles } from 'common/styles/textOverflow'

export const Name = styled.div<{
  $nameInCenter?: boolean
}>`
  display: flex;
  min-width: 0;
  flex: 1;
  align-items: center;
  justify-content: ${(props) =>
    props.$nameInCenter ? 'center' : 'flex-start'};
`

export const ProfileNameWrapper = styled.div`
  min-width: 0;
`

export const ProfileNamePhotoline = styled.div`
  max-width: 100%;
  word-wrap: break-word;
`

export const TruncateText = styled.div`
  ${textOverflowStyles};
`

const margin = 5

export const StatusWrapper = styled.div<{
  $withBackground?: boolean
  $withoutMarginInChild?: boolean
}>`
  display: flex;

  ${({ theme }) => theme.marginLeft}: 2px;

  ${({ $withoutMarginInChild, theme }) =>
    $withoutMarginInChild &&
    `
     margin: 0;

     & span {
      margin: 0;
      ${theme.marginRight} : 4px;
     }
  `};

  ${({ $withBackground }) =>
    $withBackground &&
    css`
      position: relative;
      ${({ theme }) => `${theme.marginLeft}: ${margin * 2}px`};

      &::before {
        content: '';
        position: absolute;
        inset: -${margin}px -${margin}px -${margin}px -${margin}px;
        background-color: rgba(var(--static-black-rgb), 0.8);
        border-radius: 18px;
      }
    `};
`
